export default class Filter {
    constructor(el) {
        this.el = el;
        this.selects = this.el.getElementsByTagName('select');

        for (let i = 0; i < this.selects.length; i++) {
            this.selects[i].onchange = this.onChange.bind(this);
        }
    }

    onChange(event) {
        event.preventDefault();

        // build url
        let url = this.buildUrl();

        // check if url is different than current
        if (url !== window.location.href) {
            // navigate to new url
            window.location = url;
        }
    }

    buildUrl() {
        let parts = [];
        for (let i = 0; i < this.selects.length; i++) {
            let select = this.selects[i];
            let partIndex = select.getAttribute('data-url-index');

            parts[partIndex] = select.options[select.selectedIndex].value.replace(/\/$/g, '');
        }

        return parts.join('/') + '/';
    }
}